import {RootState} from 'app/rootReducer';
import {SliceStatus} from 'interfaces';

import {createSelector} from '@reduxjs/toolkit';

import {PaymentState} from './paymentSlice';

function getPayment(state: RootState): PaymentState {
  return state.payment;
}

export const selectManageSubStatus = createSelector(
  getPayment,
  payment => payment.manageSubStatus,
);

export const selectPaystackAuthorizationStatus = createSelector(
  getPayment,
  payment => payment.paystackAuthorization.status,
);

export const selectPaypalCardList = createSelector(
  getPayment,
  payment => payment.paypalCards,
);

export const selectPaystackCardList = createSelector(
  getPayment,
  payment => payment.paystackCards,
);

export const selectReceipts = createSelector(
  getPayment,
  payment => payment.receipts,
);
export const selectFetchReceiptsIsLoading = createSelector(
  getPayment,
  payment => payment.status === SliceStatus.pending,
);

/**
 * Returns the currently active experience plan or undefined.
 */
export const selectExperiencePlans = createSelector(
  getPayment,
  payment => payment.experiencePlans,
);

/**
 * Returns the trial status.
 */
export const selectExperienceTrialsStatus = createSelector(
  getPayment,
  payment => payment.experienceTrialsStatus,
);

/**
 * Returns the subscription action status for subscribe/cancel of experience plan.
 */
export const selectSubscribeToExperiencePlanStatus = createSelector(
  getPayment,
  payment => payment.subscribeToExperiencePlanStatus,
);

/**
 * Returns the subscription action status for subscribe/cancel of experience plan.
 */
export const selectSubscribeToExperiencePlanIsPending = createSelector(
  getPayment,
  payment => payment.subscribeToExperiencePlanStatus === SliceStatus.pending,
);

/**
 * Returns the fetch status of currently active experience plan.
 */
export const selectGetExperiencePlansStatus = createSelector(
  getPayment,
  payment => payment.getExperiencePlansStatus,
);
